const DropdownMenuDivider = () => {
  return <hot-dropdown-menu-divider slot="menu" />
}

export default DropdownMenuDivider
